import Wrapper from '@app/Wrapper.js'

Munio.CompanyManager = class extends Wrapper {
  component() {
    return import('./App.vue')
  }
}

Munio.CompanyManager.Access = class extends Wrapper {
  constructor(selector, accountId) {
    super(selector, { accountId })
  }

  component() {
    return import('./Access/App.vue')
  }
}

Munio.CompanyManager.Account = class extends Wrapper {
  constructor(selector, company) {
    super(selector, { company })
  }

  component() {
    return import('./Account/App.vue')
  }
}

Munio.CompanyManager.Users = class extends Wrapper {
  constructor(selector, company) {
    super(selector, { company })
  }

  component() {
    return import('./Users/App.vue')
  }
}

Munio.CompanyManager.Courses = class extends Wrapper {
  constructor(selector, companyId, accountId) {
    super(selector, { companyId, accountId })
  }

  component() {
    return import('./Courses/App.vue')
  }
}

Munio.CompanyManager.Details = class extends Wrapper {
  constructor(selector, company) {
    super(selector, { company })
  }

  component() {
    return import('./Details/App.vue')
  }
}

Munio.CompanyManager.EcoID = class extends Wrapper {
  constructor(selector, company) {
    super(selector, { company })
  }

  component() {
    return import('./EcoId/App.vue')
  }
}
